import "../k";

let isTransitioning;

export async function goTransition(sceneName: string, ...args: any[]) {
  if (isTransitioning) return;

  const TRANSITION_DURATION = 0.15;
  const U_RSTOP_OFFSET = 0.25;
  const U_RSTOP_MULTIPLIER = 0.75;
  const SET_TIMEOUT_DELAY = 10;

  const commonShaderProps = (u_time_val: number, lalpha: number, ralpha: number) => ({
    "u_lalpha": lalpha,
    "u_ralpha": ralpha,
    "u_lstop": u_time_val,
    "u_rstop": U_RSTOP_OFFSET + u_time_val * U_RSTOP_MULTIPLIER,
    "u_x": 0,
    "u_w": 1
  });

  const commonComponents = () => [
    uvquad(width(), height()),
    color(BLACK),
    z(999),
    fixed(),
    stay(),
  ];

  let u_time = 0;
  const transitionEffect = add([
    ...commonComponents(),
    shader("vgradient", () => commonShaderProps(u_time, 1, 0)),
  ]);

  isTransitioning = true;

  await tween(0, 1, TRANSITION_DURATION, (value) => {
    u_time = value;
  }, easings.linear);

  go(sceneName, ...args);

  await wait(SET_TIMEOUT_DELAY/1000);

  let u_time_in = 0;
  const fade_in_effect = add([
    ...commonComponents(),
    shader("vgradient", () => commonShaderProps(u_time_in, 0, 1)),
  ]);

  transitionEffect.destroy();

  await tween(0, 1, TRANSITION_DURATION, (value) => {
    u_time_in = value;
  }, easings.easeOutCirc);

  fade_in_effect.destroy();

  isTransitioning = false;
}
